import React from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../Redux/authSlice";

export default function SidebarLogout() {
  const dispatch = useDispatch();

  const handleLogout = (e) => {
    e.preventDefault();
    document.body.classList.remove("sidebar-open");
    dispatch(logout());
  };

  return (
    <div className="sidebar-logout">
      <Link
        to="/"
        className="sidebar-logout__link"
        onClick={handleLogout}
        title="Logout"
        aria-label="Logout"
      >
        <i className="ti-lock" aria-hidden="true"></i>
        <span className="sidebar-logout__text">Logout</span>
      </Link>
    </div>
  );
}
